import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

import { Colors } from 'works/legacy/lib/style-helper';

export function CancelButton({ onSubmit }) {
  return (
    <Button
      onClick={onSubmit}
      size="large"
      type="primary"
      style={{ background: Colors.coral, borderColor: 'transparent' }}
    >
      Cancel Assignment
    </Button>
  );
}

CancelButton.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};
